"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Constants {
}
exports.Constants = Constants;
Constants.CARDS_NUMBER_TAKE_EACH_TIME = 10;
